const SpeedScore = {
  styles: {
    backgroundColor: "#024CB6",
    // backgroundColor: "#0d6efd",
  },
  title: "SpeedScore",
  abstract:
    "Full-stack web application for speed golfers to record stats, manage friends, and access a feed mode",
  point1:
    "Implemented Google authentication for user login and used accessibility standards to ensure compliance and improve app usability",
  point2:
    "Designed and developed a badge system that depends on golfer's stats to incentivize engagement and improve user retention",
  point3:
    "Collaborated with a team of developers to ensure code quality, maintainability, and scalability",
  summary:
    "SpeedScore demonstrates my ability to build full-stack applications, explain technical systems, and connect programming concepts to real-world projects.",
  links: {
    github: "https://github.com/JeremiahStrzelczyk/speedscore",
    live: "https://speedscore.onrender.com/",
    contributions:
      "https://github.com/JeremiahStrzelczyk/speedscore/commits/master",
  },

  stack: [
    "JavaScript |",
    "HTML |",
    "CSS |",
    "Express.js |",
    "Node.js |",
    "MongoDB |",
    "React |",
    "Passport.js",
  ],
  image: {
    alt: "SpeedScore",
    width: "1186",
    height: "848",
  },
};

const Featherdusters = {
  styles: {
    backgroundColor: "#5C514C",
    // backgroundColor: "#85756a",
  },
  title: "Featherdusters LLC",
  abstract:
    "Multi-page, mobile-first website built, maintained, and refactored for a local business",

  point1:
    "Led front-end development and collaborated with business owners to gather requirements and create a website that met their needs",

  point2:
    "Implemented accessibility standards to ensure compliance and improve app usability for a wider range of users",

  point3:
    "Improved website performance through testing, debugging, and optimization",

  summary:
    "This project demonstrates my ability to gather requirements, build practical web solutions, and communicate technical ideas clearly with non-technical users.",

  links: {
    github:
      "https://github.com/JeremiahStrzelczyk/waterfowl-guiding-feather-dusters",
    live: "https://www.featherdustersllc.com/",
    contributions:
      "https://github.com/JeremiahStrzelczyk/waterfowl-guiding-feather-dusters/commits/main",
  },
  stack: ["JavaScript |", "HTML |", "CSS |", "React"],
  image: {
    alt: "Featherdusters LLC",
    width: "1209",
    height: "851",
  },
};

export { SpeedScore, Featherdusters };
